import React from 'react';
import {
  Highlight,
  connectStateResults,
  connectHits,
  Snippet,
} from 'react-instantsearch-dom';

import { Link } from 'gatsby';
import { algoliaVersions, cloudRelease } from '../../config/site';

import './Results.scss';

function Hit({ hits }) {
  return (
    <ul className="hits-wrapper">
      {hits.map((hit) => {
        return (
          <li key={hit.objectID} className="hit">
            <Link className="hit-link" to={`/${hit.version}/${hit.slug}/`}>
              <div className="hit-name">
                <Highlight className="header" attribute="header" hit={hit} />
                <Highlight className="title" attribute="title" hit={hit} />
              </div>
              <div className="hit-description">
                <p>
                  <Snippet attribute="text" hit={hit} separator="..." />
                </p>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}

const HitWithData = connectHits(Hit);

function FilterSearch({ version: selectedVersion, setVersion }) {
  function handleChange(e) {
    setVersion(e.target.value);
  }
  return (
    <div className="filter-search">
      <h3 className="toc-version-list-title">Versions</h3>
      <div className="toc-version-list">
        {algoliaVersions.map((version) => (
          <div className="form-check" key={version}>
            <label className="form-check-label">
              <input
                className="form-check-input"
                type="radio"
                name="version"
                value={version}
                onChange={handleChange}
                checked={version === selectedVersion}
              />
              {version}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}

function Results({
  searchState,
  searchResults,
  downshiftProps,
  version,
  setVersion,
}) {

/**
  return (
    <div className="search-results-wrapper">
      <div className="results-section">
        {searchResults && searchResults.nbHits ? (
          <div
            className={`results-section-container ${
              version === cloudRelease ? 'no-filter' : ''
            }`}
          >
            {!(version === cloudRelease) && (
              <FilterSearch version={version} setVersion={setVersion} />
            )}
            <HitWithData downshiftProps={downshiftProps} />
          </div>
        ) : (
          <div className="center-body">
            <p className="m-0">
              No results for
              <strong>{` "${searchState.query}"`}</strong>
            </p>
          </div>
        )}
      </div>
    </div>
  );
 */

 return (
  <div className="search-results-wrapper">
    <div className="results-section">
      {searchResults && searchResults.nbHits ? (
        <div className="results-section-container">
          <FilterSearch version={version} setVersion={setVersion} />
          <HitWithData downshiftProps={downshiftProps} />
        </div>
      ) : (
        <div className="center-body">
          <p className="m-0">
            No results for
            <strong>{` "${searchState.query}"`}</strong>
          </p>
        </div>
      )}
    </div>
  </div>
);

}

export default connectStateResults(Results);
